import { useSlotId } from '@react-aria/utils';
import * as React from 'react';

type FieldContextType = {
    controlId: string;
    errorId: string;
    labelId: string;
    descriptionId: string;
};

const FieldContext = React.createContext<FieldContextType | null>(null);

/**
 * Provide a field to child components.
 */
export function FieldContextProvider(props: { children: React.ReactNode }) {
    const controlId = useSlotId();
    const errorId = useSlotId();
    const labelId = useSlotId();
    const descriptionId = useSlotId();
    const value: FieldContextType = React.useMemo(
        () => ({
            controlId,
            errorId,
            labelId,
            descriptionId,
        }),
        [controlId, errorId, labelId, descriptionId]
    );
    return <FieldContext.Provider value={value}>{props.children}</FieldContext.Provider>;
}

/**
 * Access the field provided by the nearest `FieldProvider`.
 */
export function useFieldContext() {
    return React.useContext(FieldContext);
}
